"use client";

import { AwardCard, Heading, Slider } from "oddsgate-ds";
import React from "react";
import { IPost } from "@/lib/wordpress/_types/archiveGrid";
import styled from "styled-components";

export type IBlockAwardSlider = {
  attrs: {
    blockTitle?: string;
    grid?: {
      items: IPost[];
      total: number;
    };
  };
};

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  position: relative;
  padding: 10rem 4.25rem 6rem 4.25rem;

  @media (max-width: 900px) {
    padding: 2rem 1rem 2rem 1rem;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: url(/assets/components/gradient.png) center/contain no-repeat;
  }

  @media (max-width: 500px) {
    &::before {
      top: 25%;
    }
  }
`;

export default function BlockAwardsSlider({ attrs }: IBlockAwardSlider) {
  const {grid, blockTitle } = attrs || {};
  const awardsData = 
      grid &&
      grid.items.length > 0 &&
      grid.items.map(award => {
        return {
          title: award.title,
          chipLabel: award.acf?.chip_label || 'Winner',
          imageElement: (
            <img
              src={
          award.image
            ? (typeof award.image === 'string' ? award.image : award.image.url)
            : '/assets/placeholder.png'
              }
              alt={award.title}
            />
          )
        }
      })
      
  return (
    <StyledWrapper>
      <Heading tag="span" size="h2" className='d-flex align-items-center fw-bold'>{blockTitle}</Heading>
      <Slider
        slidesToShow={4}
        slidesToScroll={1}
        infinite={false}
        spacing={"2rem"}
        mediaQueries={{
          900: {
            slidesToShow: 2,
          },
          500: {
            slidesToShow: 1,
          },
        }}
        dots={true}
        variant="awards"
      >
        {awardsData && awardsData.length > 0 ? (
          awardsData.map((award, index) => (
            <AwardCard
              key={"award-" + index}
              title={award.title}
              chipLabel={award.chipLabel}
              imageElement={award.imageElement}
            />
          ))
        ) : (
          <p>No awards found</p>
        )}
      </Slider>
    </StyledWrapper>
  );
}
